module.exports = __webpack_public_path__ + "static/media/ball_1_4.c3666b5b.mp3";